import { Button } from '@bfe/moly';
import { useFm, useParams } from '@web3/base-hooks';
import { justFormatNumber } from '@web3/base-utils';
import { scTrack, WEB3_EVENT } from '@web3/base-tracking';
import { useScreenType } from '@/hooks/media';

import styles from './index.module.scss';

export const AiMemeCard = () => {
  // console.log(1)
  const fm = useFm();
  const { locale } = useParams();
  const { isMobile } = useScreenType();

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: isMobile
          ? 'url(https://s1.bycsi.com/bybit/deadpool/image-f34b666083bc42c1a94d254ec7cda4ad.png)'
          : 'url(https://s1.bycsi.com/bybit/deadpool/image-fcfba82dbd3c4f899d14c84ce6cdc28b.png)',
      }}
    >
      <div
        className={styles.title}
      >{`Welcome to Layer AI FUN: The Parallel Dimension.`}</div>
      <div className={styles.subTitle}>
        <span className={styles.num}>$150,000</span>
        {' in Airdrop Awaits!'}
      </div>
      <Button
        className={styles.btn}
        variant="primary"
        onClick={() => {
          scTrack(WEB3_EVENT.Web3UserClick, {
            page_name: 'AirdropArcade_Homepage',
            button_name: 'AIMEME',
          });
          window.open(`/${locale}/web3/6th/aiparalleldimension`, '_blank');
        }}
      >
        {fm('diveIn')}
      </Button>
    </div>
  );
};
